import Vue from 'vue';
import {
  PhArrowClockwise,
  PhArrowDown,
  PhArrowDownRight,
  PhArrowRight,
  PhArrowSquareOut,
  PhArrowFatLineRight,
  PhArrowUp,
  PhArrowUpLeft,
  PhArrowsClockwise,
  PhArrowsIn,
  PhArrowsLeftRight,
  PhArrowsOut,
  PhAt,
  PhAddressBook,
  PhBank,
  PhBriefcase,
  PhBell,
  PhBellSlash,
  PhBuildings,
  PhCamera,
  PhChartPie,
  PhChartLine,
  PhChartBar,
  PhCheck,
  PhCheckCircle,
  PhCheckSquare,
  PhListChecks,
  PhCoins,
  PhCopy,
  PhClipboard,
  PhCrown,
  PhCurrencyCircleDollar,
  PhCurrencyDollar,
  PhCalendar,
  PhCalendarCheck,
  PhCalendarX,
  PhCreditCard,
  PhDotsThreeVertical,
  PhDotsThreeOutlineVertical,
  PhDownloadSimple,
  PhEnvelope,
  PhEnvelopeOpen,
  PhEye,
  PhEyeClosed,
  PhEyeSlash,
  PhFolderSimplePlus,
  PhFilePdf,
  PhFileSearch,
  PhFileText,
  PhFiles,
  PhFunnel,
  PhGauge,
  PhGear,
  PhHandshake,
  PhHandWaving,
  PhHeadset,
  PhHouse,
  PhIdentificationBadge,
  PhIdentificationCard,
  PhInfo,
  PhListBullets,
  PhLock,
  PhLockOpen,
  PhMagnifyingGlass,
  PhMedal,
  PhMoon,
  PhNewspaper,
  PhPaperPlaneRight,
  PhPaperPlaneTilt,
  PhPencil,
  PhPencilSimple,
  PhPercent,
  PhPlus,
  PhPlusCircle,
  PhProhibit,
  PhPushPin,
  PhQuestion,
  PhReceipt,
  PhScales,
  PhSignOut,
  PhSun,
  PhShieldCheck,
  PhTag,
  PhTarget,
  PhTimer,
  PhTrash,
  PhTrendUp,
  PhTrendDown,
  PhUser,
  PhUserCircle,
  PhUserMinus,
  PhUserPlus,
  PhUsers,
  PhUsersThree,
  PhWallet,
  PhWarning,
  PhWrench,
  PhX,
  PhXCircle,
  PhMinusCircle,
  PhWarningCircle,
  PhArrowUpRight,
  PhArrowDownLeft,
  PhCalendarBlank,
  PhClipboardText,
  PhFileArrowDown,
  PhFileArrowUp,
  PhMoney,
  PhPaperclip,
  PhStorefront,
  PhTruck,
  PhPhone,
  PhUserCircleGear,
  PhChatCenteredDots,
  PhClock,
  PhSwap,
  PhCaretDown,
  PhFlag,
  PhChatCircleDots,
  PhLink,
  PhCircle,
  PhPenNib,
  PhArrowLeft,
  PhAirplane,
  PhCaretDoubleUp,
  PhCaretUp,
  PhCaretDoubleDown,
  PhNotePencil,
  PhNoteBlank,
  PhEnvelopeSimple,
  PhKey,
  PhLinkBreak,
  PhClockCounterClockwise,
  PhPlugsConnected,
  PhMegaphone,
  PhCurrencyBtc,
  PhCloudArrowUp,
  PhChat,
  PhPalette,
  PhTextbox,
  PhSquare,
  PhSmiley,
  PhTextAa,
  PhSquaresFour,
  PhGlobe,
  PhFire,
  PhLightning,
  PhLightbulb,
  PhFlagCheckered,
  PhRocket,
  PhCompass,
  PhTrophy,
  PhSparkle,
  PhStar,
  PhDotsSixVertical,
  PhFolderOpen,
  PhLayout,
  PhWhatsappLogo,
  PhThumbsUp,
  PhThumbsDown,
  PhArrowCounterClockwise,
  PhMicrophone,
  PhMicrophoneSlash,
  PhRobot,
  PhStamp,
  PhTranslate
} from 'phosphor-vue';

export function registerPhosphorIcons() {
  Vue.component('PhArrowClockwise', PhArrowClockwise);
  Vue.component('PhArrowCounterClockwise', PhArrowCounterClockwise);
  Vue.component('PhArrowDown', PhArrowDown);
  Vue.component('PhArrowDownLeft', PhArrowDownLeft);
  Vue.component('PhArrowDownRight', PhArrowDownRight);
  Vue.component('PhArrowRight', PhArrowRight);
  Vue.component('PhArrowSquareOut', PhArrowSquareOut);
  Vue.component('PhArrowFatLineRight', PhArrowFatLineRight);
  Vue.component('PhArrowUp', PhArrowUp);
  Vue.component('PhArrowUpLeft', PhArrowUpLeft);
  Vue.component('PhArrowUpRight', PhArrowUpRight);
  Vue.component('PhArrowsClockwise', PhArrowsClockwise);
  Vue.component('PhArrowsIn', PhArrowsIn);
  Vue.component('PhArrowsLeftRight', PhArrowsLeftRight);
  Vue.component('PhArrowsOut', PhArrowsOut);
  Vue.component('PhAt', PhAt);
  Vue.component('PhAddressBook', PhAddressBook);
  Vue.component('PhBank', PhBank);
  Vue.component('PhBell', PhBell);
  Vue.component('PhBellSlash', PhBellSlash);
  Vue.component('PhBriefcase', PhBriefcase);
  Vue.component('PhBuildings', PhBuildings);
  Vue.component('PhCamera', PhCamera);
  Vue.component('PhCalendar', PhCalendar);
  Vue.component('PhCalendarCheck', PhCalendarCheck);
  Vue.component('PhCalendarBlank', PhCalendarBlank);
  Vue.component('PhCalendarX', PhCalendarX);
  Vue.component('PhCaretDown', PhCaretDown);
  Vue.component('PhChartPie', PhChartPie);
  Vue.component('PhChartLine', PhChartLine);
  Vue.component('PhChartBar', PhChartBar);
  Vue.component('PhCheck', PhCheck);
  Vue.component('PhCheckCircle', PhCheckCircle);
  Vue.component('PhCheckSquare', PhCheckSquare);
  Vue.component('PhChatCenteredDots', PhChatCenteredDots);
  Vue.component('PhChat', PhChat);
  Vue.component('PhChatCircleDots', PhChatCircleDots);
  Vue.component('PhCircle', PhCircle);
  Vue.component('PhClipboard', PhClipboard);
  Vue.component('PhClipboardText', PhClipboardText);
  Vue.component('PhClock', PhClock);
  Vue.component('PhCoins', PhCoins);
  Vue.component('PhCopy', PhCopy);
  Vue.component('PhCreditCard', PhCreditCard);
  Vue.component('PhCrown', PhCrown);
  Vue.component('PhCurrencyCircleDollar', PhCurrencyCircleDollar);
  Vue.component('PhCurrencyDollar', PhCurrencyDollar);
  Vue.component('PhDotsThreeVertical', PhDotsThreeVertical);
  Vue.component('PhDotsThreeOutlineVertical', PhDotsThreeOutlineVertical);
  Vue.component('PhDownloadSimple', PhDownloadSimple);
  Vue.component('PhEnvelope', PhEnvelope);
  Vue.component('PhEnvelopeOpen', PhEnvelopeOpen);
  Vue.component('PhEye', PhEye);
  Vue.component('PhEyeClosed', PhEyeClosed);
  Vue.component('PhEyeSlash', PhEyeSlash);
  Vue.component('PhFolderSimplePlus', PhFolderSimplePlus);
  Vue.component('PhFileArrowDown', PhFileArrowDown);
  Vue.component('PhFileArrowUp', PhFileArrowUp);
  Vue.component('PhFilePdf', PhFilePdf);
  Vue.component('PhFileSearch', PhFileSearch);
  Vue.component('PhFileText', PhFileText);
  Vue.component('PhFiles', PhFiles);
  Vue.component('PhFlag', PhFlag);
  Vue.component('PhFunnel', PhFunnel);
  Vue.component('PhGauge', PhGauge);
  Vue.component('PhGear', PhGear);
  Vue.component('PhHandshake', PhHandshake);
  Vue.component('PhHandWaving', PhHandWaving);
  Vue.component('PhHeadset', PhHeadset);
  Vue.component('PhHouse', PhHouse);
  Vue.component('PhIdentificationBadge', PhIdentificationBadge);
  Vue.component('PhIdentificationCard', PhIdentificationCard);
  Vue.component('PhInfo', PhInfo);
  Vue.component('PhLink', PhLink);
  Vue.component('PhListBullets', PhListBullets);
  Vue.component('PhLock', PhLock);
  Vue.component('PhLockOpen', PhLockOpen);
  Vue.component('PhMagnifyingGlass', PhMagnifyingGlass);
  Vue.component('PhSparkle', PhSparkle);
  Vue.component('PhMedal', PhMedal);
  Vue.component('PhMoney', PhMoney);
  Vue.component('PhMoon', PhMoon);
  Vue.component('PhNewspaper', PhNewspaper);
  Vue.component('PhPaperPlaneRight', PhPaperPlaneRight);
  Vue.component('PhPaperPlaneTilt', PhPaperPlaneTilt);
  Vue.component('PhPaperclip', PhPaperclip);
  Vue.component('PhPencil', PhPencil);
  Vue.component('PhPencilSimple', PhPencilSimple);
  Vue.component('PhPenNib', PhPenNib);
  Vue.component('PhPercent', PhPercent);
  Vue.component('PhPhone', PhPhone);
  Vue.component('PhPlus', PhPlus);
  Vue.component('PhPlusCircle', PhPlusCircle);
  Vue.component('PhProhibit', PhProhibit);
  Vue.component('PhPushPin', PhPushPin);
  Vue.component('PhQuestion', PhQuestion);
  Vue.component('PhReceipt', PhReceipt);
  Vue.component('PhListChecks', PhListChecks);
  Vue.component('PhScales', PhScales);
  Vue.component('PhShieldCheck', PhShieldCheck);
  Vue.component('PhSignOut', PhSignOut);
  Vue.component('PhStorefront', PhStorefront);
  Vue.component('PhSun', PhSun);
  Vue.component('PhSwap', PhSwap);
  Vue.component('PhTag', PhTag);
  Vue.component('PhTarget', PhTarget);
  Vue.component('PhTimer', PhTimer);
  Vue.component('PhTrash', PhTrash);
  Vue.component('PhTrendUp', PhTrendUp);
  Vue.component('PhTrendDown', PhTrendDown);
  Vue.component('PhTruck', PhTruck);
  Vue.component('PhUser', PhUser);
  Vue.component('PhUserCircle', PhUserCircle);
  Vue.component('PhUserCircleGear', PhUserCircleGear);
  Vue.component('PhUserMinus', PhUserMinus);
  Vue.component('PhUserPlus', PhUserPlus);
  Vue.component('PhUsers', PhUsers);
  Vue.component('PhUsersThree', PhUsersThree);
  Vue.component('PhWallet', PhWallet);
  Vue.component('PhWarning', PhWarning);
  Vue.component('PhWarningCircle', PhWarningCircle);
  Vue.component('PhWrench', PhWrench);
  Vue.component('PhX', PhX);
  Vue.component('PhXCircle', PhXCircle);
  Vue.component('PhMinusCircle', PhMinusCircle);
  Vue.component('PhArrowLeft', PhArrowLeft);
  Vue.component('PhAirplane', PhAirplane);
  Vue.component('PhCaretDoubleUp', PhCaretDoubleUp);
  Vue.component('PhCaretUp', PhCaretUp);
  Vue.component('PhCaretDoubleDown', PhCaretDoubleDown);
  Vue.component('PhNotePencil', PhNotePencil);
  Vue.component('PhNoteBlank', PhNoteBlank);
  Vue.component('PhEnvelopeSimple', PhEnvelopeSimple);
  Vue.component('PhKey', PhKey);
  Vue.component('PhLinkBreak', PhLinkBreak);
  Vue.component('PhClockCounterClockwise', PhClockCounterClockwise);
  Vue.component('PhPlugsConnected', PhPlugsConnected);
  Vue.component('PhMegaphone', PhMegaphone);
  Vue.component('PhCurrencyBtc', PhCurrencyBtc);
  Vue.component('PhCloudArrowUp', PhCloudArrowUp);
  Vue.component('PhPalette', PhPalette);
  Vue.component('PhTextbox', PhTextbox);
  Vue.component('PhSquare', PhSquare);
  Vue.component('PhSmiley', PhSmiley);
  Vue.component('PhTextAa', PhTextAa);
  Vue.component('PhSquaresFour', PhSquaresFour);
  Vue.component('PhGlobe', PhGlobe);
  Vue.component('PhFire', PhFire);
  Vue.component('PhLightning', PhLightning);
  Vue.component('PhLightbulb', PhLightbulb);
  Vue.component('PhFlagCheckered', PhFlagCheckered);
  Vue.component('PhRocket', PhRocket);
  Vue.component('PhCompass', PhCompass);
  Vue.component('PhTrophy', PhTrophy);
  Vue.component('PhStar', PhStar);
  Vue.component('PhDotsSixVertical', PhDotsSixVertical);
  Vue.component('PhFolderOpen', PhFolderOpen);
  Vue.component('PhLayout', PhLayout);
  Vue.component('PhWhatsappLogo', PhWhatsappLogo);
  Vue.component('PhThumbsUp', PhThumbsUp);
  Vue.component('PhThumbsDown', PhThumbsDown);
  Vue.component('PhArrowCounterClockwise', PhArrowCounterClockwise);
  Vue.component('PhMicrophone', PhMicrophone);
  Vue.component('PhMicrophoneSlash', PhMicrophoneSlash);
  Vue.component('PhRobot', PhRobot);
  Vue.component('PhStamp', PhStamp);
  Vue.component('PhTranslate', PhTranslate);
}

export default registerPhosphorIcons;
